import React from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {
  baseUrl,
  useCreatedSUBMutation,
  useFindUserApiQuery,
  useOnCalledPayQuery,
  useSuccessPaidMutation,
  useSuucessPaidQuery,
} from "../services/apiSlice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { Container } from "@mui/system";

export const PayPals = () => {
  const navigate = useNavigate();

  const [CreatedSUB, { data, error, isError }] = useCreatedSUBMutation();

  const {
    data: payPalSuccess,
    error: payPalError,
    isError: Iserror,
    isSuccess,
    isFetching,
  } = useSuucessPaidQuery();

  // const {
  //   data: cancle,
  //   error: payPalCancelError,
  //   isError: IserrorCan,
  //   isSuccess: success,
  //   isFetching: fetch,
  // } = useOnCalledPayQuery();
  //EOUPGhn-EmA0Yzswm4Z0L2FB-njkTpVcTULP0P18Pg4ZDIVQ247slyQm_FSPsjZHVUS7_qxQWSdLuR6F          secret
  //ARr_17PMcGF6FDaHFAKxK_y_iIFs7RwFi7rV-vQK-z8F58nLkjfPFq4li2-PqyTY2ltdsWI-xZp7GcwG           id

  const createOrder = async (data, actions) => {
    try {
      const responseData = await CreatedSUB().unwrap();
      console.log(
        { responseData },
        "responseData?.message",
        responseData?.message
      );
      // return responseData.orderId;
      // if (responseData.status === 200) {
      //   console.log(responseData.data);
      //   let id = responseData.id;
      //   // window.location = responseData.forwardLink;
      //   return id;
      // }

      if (responseData?.success === true) {
        let orderId = responseData.id;
        for (let i = 0; i < responseData.payment.links.length; i++) {
          if (responseData.payment.links[i].rel === "approval_url") {
            // res.redirect(payment.links[i].href);
            console.log("it enter redirect");
            window.location.href = responseData.payment.links[i].href;

            //   res.json({ forwardLink: payment.links[i].href });
          }
        }
        return orderId;

        // Swal.fire("Awesome!", `  ${responseData?.message}`, "success").then(
        //   (result) => {
        //     if (result.isConfirmed || result.isDismissed) {
        //       navigate(`/dashboard`);
        //     }
        //   }
        // );
      } else if (isError) {
        //error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else if (responseData?.success === false) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else if (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else {
        console.log("error", error?.data?.message);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: responseData?.message,
        });
      }
    } catch (error) {
      if (isError) {
        //error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else {
        console.log("error", error?.data?.message, error?.message);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      }
    }
  };
  const onApprove = async () => {
    try {
      if (payPalSuccess.success === true) {
        // success message
        Swal.fire("Awesome!", `  ${payPalSuccess?.message}`, "success").then(
          (result) => {
            if (result.isConfirmed || result.isDismissed) {
              navigate(`/dashboard`);
            }
          }
        );
      } else if (Iserror) {
        //error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: payPalError?.data?.message,
        });
      } else if (payPalSuccess?.success === false) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.data?.message,
        });
      } else if (payPalError) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: payPalError?.data?.message,
        });
      } else {
        console.log("error", payPalError?.data?.message);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: payPalSuccess?.message,
        });
      }
    } catch (error) {
      if (Iserror) {
        //error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: payPalError?.data?.message,
        });
      } else {
        console.log("error", payPalError?.data?.message, payPalError?.message);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: payPalError?.data?.message,
        });
      }
    }
  };
  const onError = async () => {
    return fetch(baseUrl + "cancel", {
      method: "get",
      headers: {
        "content-type": "application/json",
      },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        return data; // the data is the order object returned from the api call, its not the BrainTree.Response object
      });
    // try {
    //   if (!fetch && success) {
    //     // success message
    //     Swal.fire("Awesome!", `  ${cancle?.message}`, "success").then(
    //       (result) => {
    //         if (result.isConfirmed || result.isDismissed) {
    //           navigate(`/dashboard`);
    //         }
    //       }
    //     );
    //   } else if (IserrorCan) {
    //     //error
    //     Swal.fire({
    //       icon: "error",
    //       title: "Oops...",
    //       text: payPalCancelError?.data?.message,
    //     });
    //   }
    //   // else if (payPalSuccess?.success === false) {
    //   //   Swal.fire({
    //   //     icon: "error",
    //   //     title: "Oops...",
    //   //     text: payPalCancelError?.data?.message,
    //   //   });
    //   // }
    //   else if (payPalError) {
    //     Swal.fire({
    //       icon: "error",
    //       title: "Oops...",
    //       text: payPalCancelError?.data?.message,
    //     });
    //   }
    //   // else {
    //   //   console.log("error", payPalError?.data?.message);
    //   //   Swal.fire({
    //   //     icon: "error",
    //   //     title: "Oops...",
    //   //     text: responseData?.message,
    //   //   });
    //   // }
    // } catch (error) {
    //   if (IserrorCan) {
    //     //error
    //     Swal.fire({
    //       icon: "error",
    //       title: "Oops...",
    //       text: payPalCancelError?.data?.message,
    //     });
    //   } else {
    //     console.log(
    //       "error",
    //       payPalCancelError?.data?.message,
    //       payPalCancelError?.message
    //     );
    //     Swal.fire({
    //       icon: "error",
    //       title: "Oops...",
    //       text: payPalCancelError?.data?.message,
    //     });
    //   }
    // }
  };
  const onCancle = async () => {};

  return (
    // // <PayPalScriptProvider deferLoading={true} /* options={initialOptions} */>
    // // </PayPalScriptProvider>
    // <PayPalButtons />
    // <main className="flex flex-col items-center justify-center flex-1 px-20 text-center border rounded-xl border-black">
    //   <h1 className="text-6xl font-bold">
    //     Payments with{" "}
    //     <a className="text-blue-600" href="https://paypal.com">
    //       Paypal!
    //     </a>
    //   </h1>
    //   <h1 className="text-gray-500 mt-5 font-medium mb-5">
    //     Pay by card with Paypal
    //   </h1>
    //   <div className="mt-1 max-w-md">
    //     {/* <PayPalButtons
    //       style={{
    //         color: "blue",
    //         shape: "pill",
    //         label: "pay",
    //         tagline: false,
    //         layout: "horizontal",
    //       }}

    //       // createOrder={createOrder}
    //       // onApprove={onApprove}
    //       // onError={onError}
    //     /> */}
    //     <PayPalScriptProvider
    //       options={{
    //         "client-id":
    //           "ARr_17PMcGF6FDaHFAKxK_y_iIFs7RwFi7rV-vQK-z8F58nLkjfPFq4li2-PqyTY2ltdsWI-xZp7GcwG",
    //       }}
    //     >
    //       <PayPalButtons
    //         style={{
    //           color: "blue",
    //           shape: "pill",
    //           label: "pay",
    //           tagline: false,
    //           layout: "horizontal",
    //         }}
    //         createOrder={createOrder}
    //         onApprove={onApprove}
    //         onError={onError}
    //       />
    //     </PayPalScriptProvider>
    //     {/* Show an error message on the screen if payment fails */}
    //     {/* {paypalErrorMessage && (
    //       <p className="text-red-600">{paypalErrorMessage}</p>
    //     )} */}

    //     <p className="mt-1 text-gray-900 font-semibold">
    //       Payer details will show up below once payment is completed:
    //     </p>

    //     {/* {succeeded && (
    //         <section>

    //           {billingDetails && (
    //             <div>
    //               <pre>{JSON.stringify(billingDetails, undefined, 2)}</pre>
    //             </div>
    //           )}
    //         </section>
    //       )} */}
    //   </div>
    // </main>
    <Container>
      <Box
        sx={{
          maxWidth: "690px",
          my: 3,
          px: 4,
        }}
      >
        <Typography
          variant="h1"
          component="h2"
          className="md:text-3xl text-lg md:font-extrabold text-center py-12"
        >
          Go premium, to enjoy the full benefit of Top Neigborhood Pro and
          functionality
        </Typography>

        <PayPalScriptProvider
          options={{
            "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
          }}
        >
          <PayPalButtons
            style={{
              color: "blue",
              shape: "pill",
              label: "pay",
              tagline: false,
              layout: "horizontal",
            }}
            createOrder={createOrder}
            onApprove={onApprove}
            onError={onError}
          />
        </PayPalScriptProvider>
      </Box>
    </Container>
  );
};
